import React, { useState } from 'react'
import { object, string } from "yup";
import * as yup from "yup";

const useModalUpdate = () => {
    const [isModalUpdate, setModalUpdate] = useState(false)

    const openModalUpdate = () =>{
        setModalUpdate(true)
    }

    const closedModalUpdate = () =>{
       setModalUpdate(false)
    }

    const validation = object({
       contextoId: yup.number().notOneOf([0], "O Contexto é um campo obrigatório").required("O Contexto é um campo obrigatório"),
       localId: yup.number().notOneOf([0], "O Local é um campo obrigatório").required("O Local é um campo obrigatório"),
       contato: string()
        .matches(/^[A-Za-zÀ-ÿ\sáéíóúâêîôûãõç]{1,50}$/, "O contato deve conter apenas letras e espaços e ter no máximo 50 caracteres")
        .required("O Contato é um campo obrigatório"),
     });

    const [initial, setInitial] = useState({
      contextoId: 0,
      localId: 0,
      contato: "",
   });

  return {
     isModalUpdate,
     setModalUpdate,
     openModalUpdate,
     closedModalUpdate,
     initial,
     setInitial,
     validation
  }
}

export default useModalUpdate